import { Pipe, PipeTransform } from "@angular/core";
import {
  BrandImgConstants,
  BrandImgShortConstants,
} from "./barand-img.constatns";
import { Mid } from "src/app/constants/mids";

@Pipe({
  name: "brandImgByMid",
})
export class BrandImgByMidPipe implements PipeTransform {
  transform(value: unknown, variant: "short" | "full" = "full"): string {
    if (!value) return;

    if (!Object.values(Mid).includes(value as Mid)) {
      return;
    }

    if (variant === "short") {
      return BrandImgShortConstants[value as Mid];
    }

    return BrandImgConstants[value as Mid];
  }
}
